import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type IssueResponseDto,
  type AssignIssueRequestDto,
  useApi,
} from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export function useAssignIssue(
  code: string,
  onError: (error: ExtendedAxiosError) => void,
) {
  const api = useApi();

  const queryClient = useQueryClient();

  return useMutation<
    IssueResponseDto,
    ExtendedAxiosError,
    AssignIssueRequestDto
  >({
    mutationKey: ['issues', code],
    mutationFn: (r) => api.issuesApi.assignIssue(code, r).then((r) => r.data),
    onSuccess: async (response) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['users', 'roles'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['user-roles', code],
        }),
      ]);
      queryClient.setQueryData<IssueResponseDto>(['issues', code], response);
    },
    onError,
  });
}
